import { normalizeHandle } from "./handle-resolver";

export async function lookupHandleAssignment(
  recipientKey: string,
): Promise<string | null> {
  const response = await fetch(
    `/api/handles/assignment?recipientKey=${encodeURIComponent(recipientKey)}`,
    { cache: "no-store" },
  );
  const data = await response.json().catch(() => null);
  if (
    !response.ok ||
    data?.success !== true ||
    data?.recipientKey !== recipientKey ||
    (data.handle !== null &&
      (!data.handle || normalizeHandle(data.handle) !== data.handle))
  ) {
    throw new Error(
      "Cannot check your account’s handle right now. Please try again.",
    );
  }
  return data.handle;
}
